import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Group } from 'utils';

interface ConfirmProfilePhotoImportPayload {
    upload_token: string;
    action: 'apply' | 'cancel';
    manual_matches?: Array<{
        filename: string;
        member_uuid: string;
    }>;
}

interface ConfirmResponse {
    status: string;
    total_photos?: number;
}

type ReturnType = Promise<AxiosResponse<ConfirmResponse>>;

const confirmProfilePhotoImport = (
    group: Group,
    payload: ConfirmProfilePhotoImportPayload,
): ReturnType => {
    return Request.post(`/imports/group/members/${group.uuid}/photos/confirm`, payload);
};

export default confirmProfilePhotoImport;
